export default __webpack_public_path__ + "static/media/leaves-r.5172d595.png";